import SongSearchList from './SongSearchList'

function PanelLeft({ setSelectedSong }) {
  return (
    <div className="library-col">
      <SongSearchList onSelect={setSelectedSong} />
    </div>
  )
}

export default PanelLeft
